import React from "react";
import { Container } from "react-bootstrap";

//Background Images
import mainBackground from "../../assets/backgrounds/mountains.png";

const MainBody = (props) => {
  return (
    <Container fluid style={styles.mainBodyStyle}>
      {props.children}
    </Container>
  );
};

export default MainBody;

const styles = {
  mainBodyStyle: {
    height: "100%",
    paddingTop: 120,
    paddingBottom: 120,
    // Dark gradient overlay keeps text readable over the photo
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.75)), url(${mainBackground})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    verticalAlign: "middle",
  },
};
